import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import DateRange from 'components/Form/DateRange';
import { LegalAssociationsAdvocatingItemModel } from 'forms/sections/legal/associations/advocating/types';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import { AccordionItemProps } from 'components/Form/Accordion/types';
import {
  CommonOnUpdate,
  CommonScrollIntoView,
  CommonRequired,
  CommonOnError,
  CommonAddressBooks,
} from 'types/props';

interface Props
  extends ValidationElementProps,
    Partial<LegalAssociationsAdvocatingItemModel>,
    AccordionItemProps {
  onUpdate?: CommonOnUpdate
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  onError?: CommonOnError
  addressBooks?: CommonAddressBooks
}

export default class AdvocatingItem extends ValidationElement<Props> {
  update = (queue: Partial<LegalAssociationsAdvocatingItemModel>) => {
    this.props.onUpdate({
      Reasons: this.props.Reasons,
      Dates: this.props.Dates,
      ...queue,
    });
  };

  updateReasons = (values: LegalAssociationsAdvocatingItemModel['Reasons']) => {
    this.update({
      Reasons: values,
    });
  };

  updateDates = (values: LegalAssociationsAdvocatingItemModel['Dates']) => {
    this.update({
      Dates: values,
    });
  };

  render() {
    const attribute = `List.items[${this.props.$index}].Item`;
    return (
      <div>
        <Field
          attribute={`${attribute}.Reasons`}
          title={i18n.t('legal.associations.advocating.heading.reasons')}
          adjustFor="textarea"
          scrollIntoView={this.props.scrollIntoView}
        >
          <Textarea
            attribute={`${attribute}.Reasons`}
            name="Reasons"
            {...this.props.Reasons}
            onUpdate={this.updateReasons}
            onError={this.props.onError}
            className="legal-associations-advocating-reasons"
            required={this.props.required}
          />
        </Field>

        <Field
          attribute={`${attribute}.Dates`}
          title={i18n.t('legal.associations.advocating.heading.dates')}
          help="legal.associations.advocating.help.dates"
          adjustFor="daterange"
          scrollIntoView={this.props.scrollIntoView}
        >
          <DateRange
            attribute={`${attribute}.Dates`}
            name="Dates"
            {...this.props.Dates}
            minDateEqualTo
            onUpdate={this.updateDates}
            onError={this.props.onError}
            className="legal-associations-advocating-dates"
            required={this.props.required}
            hideFromDay
            hideToDay
          />
        </Field>
      </div>
    );
  }
}

AdvocatingItem.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
};
